module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Abby Green\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Abby Green spent her teens reading Mills & Boon romances. She then spent many years working in the Film and TV industry as an Assistant Director. One day while standing outside an actor's trailer in the rain, she thought: "), _c('I', [_vm._v("there has to be more than this. ")]), _vm._v("So she sent off a partial to Harlequin Mills & Boon. After many rewrites, they accepted her first book and an author was born. She lives in Dublin, Ireland and you can find out more here: www.abby-green.com")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hYQAsK/tc-custom/9781488044953.jpg?1726519363430",
      "alt": "This image is the cover for the book Confessions of a Pregnant Cinderella"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Confessions of a Pregnant Cinderella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Opposites attract when a one-night stand results in pregnancy in this sexy international romance from a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Her shocking announcement will alter his life—forever!"), _c('br'), _c('br'), _vm._v("Compassionate waitress Skye O’Hara has imagined this moment. It’s her chance to finally tell imposing Lazaro Sanchez that their unexpected and intense passion had consequences. Skye is determined to prevent her son from experiencing the chaos of her own childhood. But what can she expect from a playboy billionaire?"), _c('br'), _c('br'), _vm._v("When she confronts him with the truth at an exclusive gala, their still-sizzling connection hits her like a thunderbolt. And what Lazaro says to her next is even more outrageous than her own confession . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0